import axios from 'axios';
import qs from 'qs';
import { starter2Api } from '../constants/Endpoint';
import { adios } from '@adserve/adserve-react-components';
import { WorkflowTypes } from '../constants/Enums';

export const CreateReservationRequest = async (workflowId, quoteId, hours) => {
    const json = JSON.stringify({
        workflowType: WorkflowTypes.CAMPAIGNQUOTE,
        objectId: quoteId,
        hours,
        uri: `${window.location.origin}/campaign-manager/campaigns/action`
    });
    const result = await adios(() =>
        axios.post(`${starter2Api}/workflow/request`, {
            workflowId: workflowId,
            objectId: quoteId,
            workflowType: WorkflowTypes.CAMPAIGNQUOTE,
            jsonData: json
        })
    );
    return result.data;
};

export const CreateCampaignValuePotRequest = async (
    workflowId,
    campaignId,
    valuePotAmt
) => {
    const json = JSON.stringify({
        workflowType: WorkflowTypes.VALUEPOT,
        objectId: campaignId,
        valuePotAmt,
        uri: `${window.location.origin}/campaign-manager/campaigns/action`
    });
    const result = await adios(() =>
        axios.post(`${starter2Api}/workflow/request`, {
            workflowId: workflowId,
            jsonData: json,
            objectId: campaignId,
            workflowType: WorkflowTypes.VALUEPOT
        })
    );
    return result.data;
};

export const CreateCampaignSpotTypeDistributionRequest = async (
    workflowId,
    campaignId
) => {
    const json = JSON.stringify({
        workflowType: WorkflowTypes.SPOTTYPEDISTRIBUTION,
        objectId: campaignId,
        uri: `${window.location.origin}/campaign-manager/campaigns/action`
    });
    const result = await adios(() =>
        axios.post(`${starter2Api}/workflow/request`, {
            workflowId: workflowId,
            jsonData: json,
            objectId: campaignId,
            workflowType: WorkflowTypes.SPOTTYPEDISTRIBUTION
        })
    );
    return result.data;
};

export const CreateCampaignDiscountRequest = async (
    workflowId,
    campaignId,
    percentageDiscount,
    discountValue
) => {
    const json = JSON.stringify({
        workflowType: WorkflowTypes.CAMPAIGNDISCOUNT,
        objectId: campaignId,
        percentageDiscount,
        discountValue,
        uri: `${window.location.origin}/campaign-manager/campaigns/action`
    });
    const result = await adios(() =>
        axios.post(`${starter2Api}/workflow/request`, {
            workflowId: workflowId,
            jsonData: json,
            objectId: campaignId,
            workflowType: WorkflowTypes.CAMPAIGNDISCOUNT
        })
    );
    return result.data;
};

export const CreateBookingRequest = async (workflowId, campaignId, quoteId, campaignApprovalTeam, workflowType) => {
    const json = JSON.stringify({
        workflowType: workflowType,
        objectId: quoteId,
        uri: `${window.location.origin}/campaign-manager/campaigns/action`,
        campaignApprovalTeam: campaignApprovalTeam
    });
    const result = await adios(() =>
        axios.post(`${starter2Api}/workflow/bookingRequest`, {
            workflowId: workflowId,
            quoteId: quoteId,
            jsonData: json,
            workflowType: workflowType
        })
    );
    return result.data;
};

export const CreateCampaignCancellationRequest = async (
    workflowId,
    campaignId,
    campaignBurstId,
    campaignApprovalTeamId
) => {
    var requestData = {
        workflowType: WorkflowTypes.CAMPAIGNCANCELLATION,
        objectId: campaignId,
        uri: `${window.location.origin}/campaign-manager/campaigns/action`
    };

    if (campaignApprovalTeamId) {
        requestData.CampaignApprovalTeam = campaignApprovalTeamId;
    }

    if (campaignBurstId) {
        requestData.campaignBurstId = campaignBurstId;
    }

    const json = JSON.stringify(requestData);

    const result = await adios(() =>
        axios.post(`${starter2Api}/workflow/request`, {
            workflowId: workflowId,
            jsonData: json,
            objectId: campaignId,
            workflowType: WorkflowTypes.CAMPAIGNCANCELLATION
        })
    );

    return result.data;
};

export const ActionWorkflow = async (requestId, transitionId, actionId) => {
    const response = await adios(() =>
        axios.post(`${starter2Api}/workflow/actionRequest`, {
            requestId,
            transitionId,
            actionId
        })
    );

    return response?.data;
};

export const GetActiveRequest = async (workflowId, objectId) => {
    const result = await adios(() => axios.get(`${starter2Api}/workflowRequest/${workflowId}/${objectId}`));
    return result?.data;
};

export const GetWorkflowRequest = async (workflowRequestId) => {
    const result = await adios(() => axios.get(`${starter2Api}/workflowRequest/${workflowRequestId}`));
    return result?.data;
};

export const GetWorkflowTeams = async () => {
    try {
        const result = await adios(() =>
            axios.get(`${starter2Api}/workflowTeams/Search`, {
                params: {
                    pageNumber: 1,
                    pageSize: -1
                }
            })
        );
        return result?.data?.data;
    } catch (err) {
        console.error(err);
    }
};

export const UsingDynamicWorkflow = async (workflowIds) => {
    const result = await adios(() => axios.get(`${starter2Api}/workflows/isUsingDynamic`, {
        params: {
            workflowIds
        },
        paramsSerializer: (params) => {
            return qs.stringify(params);
        }
    }));
    return result?.data;
};

export const CancelWorkflowRequest = async (requestId) => {
    const result = await adios(() =>
        axios.delete(`${starter2Api}/workflowRequests/cancelApprovalRequest/${requestId}`)
    );

    return result;
};
